import { render, staticRenderFns } from "./NanoReactorIntroduce.vue?vue&type=template&id=532e3dd2&scoped=true&"
import script from "./NanoReactorIntroduce.vue?vue&type=script&lang=js&"
export * from "./NanoReactorIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./NanoReactorIntroduce.vue?vue&type=style&index=0&id=532e3dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e3dd2",
  null
  
)

component.options.__file = "NanoReactorIntroduce.vue"
export default component.exports